/// REACT ///
import { useEffect } from "react";
import { useState } from "react";
/// HOOKS ///
import { useAppDispatch } from "api/hooks/apiHook";
/// ACTIONS ///
import { createRestorePoint } from "api/actions/history";
import { updateLocalShopSink } from "api/actions/shop_quote";
import { updateShopSink } from "api/actions/shop_quote";
import { restore } from "api/actions/history";
import { replaceRestorePoint } from "api/actions/history";
import { markShopQuoteChanged } from "api/actions/shop_quote";
/// ACTION TYPES ///
import { IHistoryActionType } from "api/types/history";
/// TYPES ///
import { CutoutError } from "api/types/sketch";
import { IShopCounter } from "api/types/shop_quote/counter";
import { IShopSink } from "api/types/shop_quote/sink";
/// COMPONENTS ///
import SaveSink from "components/quote/drawer/sink";
/// VALUES ///
import { UNDERMOUNT } from "values/values";
import { RECTANGLE } from "values/values";

interface Props {
  setSelectedSink: (sink: IShopSink | null) => void,
  open: boolean,
  setOpen: (open: boolean) => void,
  setSelectedCounter: (selected_counter: IShopCounter | null) => void,
  selected_sink: IShopSink,
  current_sink: IShopSink
}

export default function UpdateShopSink({
  setSelectedSink,
  selected_sink,
  setSelectedCounter,
  open,
  setOpen
}: Props) {
  const dispatch = useAppDispatch();
  const [sink, setSink] = useState<IShopSink>({});
  const [error, setError] = useState<CutoutError>({});

  useEffect(() => {
    if (open && selected_sink) {
      setSink(selected_sink);
      dispatch(replaceRestorePoint(
        {
          undo_action: IHistoryActionType.UPDATE_SHOP_SINK,
          desc: "Cancel Update Sink",
          undo_data: { ...selected_sink }
        }
      ));
    }
  }, [open]);

  const cancel = () => {
    dispatch(restore());
    setOpen(false);
    setSelectedSink(null);
  }

  const save = () => {
    let error: CutoutError = {};
    if (!sink?.length) {
      error.length_error = "Length must be greater than 0";
      error.length_has_error = true;
    }
    if (!sink?.width) {
      error.width_error = "Width must be greater than 0";
      error.width_has_error = true;
    }

    if (error.length_has_error || error.width_has_error) {
      setError(error);
      return;
    }

    dispatch(updateShopSink(sink, sink.id));
    dispatch(markShopQuoteChanged());


    dispatch(createRestorePoint(
      {
        undo_action: IHistoryActionType.UPDATE_SHOP_SINK,
        redo_action: IHistoryActionType.UPDATE_SHOP_SINK,
        desc: "Update Sink",
        undo_data: { ...selected_sink },
        redo_data: sink
      }
    ));
    setSelectedSink(null);
    setSelectedCounter(null);
    setOpen(false);
  }

  const update = (updated_sink: IShopSink) => {
    setSink(updated_sink);
    dispatch(updateLocalShopSink(updated_sink));
  }

  return (
    <SaveSink
      open={open}
      setOpen={setOpen}
      sink_type={sink?.sink_type ?? UNDERMOUNT}
      setSinkType={sink_type => update({ ...sink, sink_type })}
      shape={sink?.shape ?? RECTANGLE}
      setShape={shape => update({ ...sink, shape })}
      faucet_hole_count={sink?.faucet_hole_count ?? 1}
      setFaucetHoleCount={faucet_hole_count => update({ ...sink, faucet_hole_count })}
      length={sink?.length ?? 30}
      setLength={length => update({ ...sink, length })}
      length_error={error?.length_error ?? ""}
      length_has_error={error?.length_has_error ?? false}
      width={sink?.width ?? 26}
      setWidth={width => update({ ...sink, width })}
      width_error={error?.width_error ?? ""}
      width_has_error={error?.width_has_error ?? false}
      save={save}
      cancel={cancel}
      title="Edit Sink Cutout" />
  );
}
